import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Heart, Image as ImageIcon } from 'lucide-react';

export const LifeBeyondWork = ({ data }) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  const activityImages = {
    "Travelling": "/images/lifestyle-food-counter.jpeg",
    "Understanding Cultures": "/images/lifestyle-food-plate.jpeg",
    "Trying Local Cuisines": "/images/lifestyle-turkish-coffee.jpeg",
    "Walking Through Old Cities": "/images/travel-white-village-street.jpeg",
    "Board Games": "/images/travel-yellow-cave.jpeg",
    "Reading": "/images/boardgame-cascadia.jpeg"
  };

  return (
    <section className="py-24 md:py-32 bg-gray-50 dark:bg-gray-800">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16">
          <Heart className="w-12 h-12 text-rose-500 mx-auto mb-6" />
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 dark:text-white mb-6">
            {data.title}
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-2xl mx-auto italic">
            {data.description}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {data.activities.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              className="group bg-white dark:bg-gray-900 rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500">
              {/* Image */}
              <div className="aspect-[4/3] bg-gradient-to-br from-amber-100 to-rose-100 dark:from-gray-700 dark:to-gray-600 flex items-center justify-center overflow-hidden">
                {activityImages[item.activity] ? (
                  <img 
                    src={activityImages[item.activity]} 
                    alt={item.activity} 
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                ) : (
                  <ImageIcon className="w-16 h-16 text-gray-400 dark:text-gray-500" />
                )}
              </div>
              
              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2 group-hover:text-amber-600 dark:group-hover:text-amber-400 transition-colors">
                  {item.activity}
                </h3>
                <p className="text-gray-600 dark:text-gray-400">{item.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};